import { useEffect } from 'react';
import { useRouter } from 'next/router';

type TCFAPI = {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    __tcfapi?: any;
};

export type WindowWithTCFAPI = Window & typeof globalThis & TCFAPI;

export const useShowCookiePolicy = () => {
    const router = useRouter();
    const shouldShowCookiePolicyOpen = Boolean(router.query['cookie_policy']);

    useEffect(() => {
        if (!shouldShowCookiePolicyOpen) {
            return;
        }

        const showCookiePolicy = setTimeout(() => {
            // at the moment there is a bug with the LiveRamp cookie banner api
            // where we cannot show the consentManager, unless
            // - cookie policy has been accepted
            // - cookie banner is hidden
            (window as WindowWithTCFAPI).__tcfapi?.(
                'checkConsent',
                2,
                (exists: boolean) => {
                    // - cookie policy has been accepted
                    if (exists) {
                        (window as WindowWithTCFAPI).__tcfapi(
                            'showConsentManager',
                            2
                        );
                        return;
                    }

                    // - hide cookie banner
                    (window as WindowWithTCFAPI).__tcfapi(
                        'toggleConsentTool',
                        2,
                        () => {
                            (window as WindowWithTCFAPI).__tcfapi(
                                'showConsentManager',
                                2
                            );
                        }
                    );
                }
            );
        }, 1000);

        return () => {
            clearTimeout(showCookiePolicy);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldShowCookiePolicyOpen]);
};
